import { EquipmentModel, AssignedEquipmentModel, EquipmentWithAssignmentsModel, EquipmentClassCodeModel, EquipmentClassificationModel, EquipmentTypeModel } from './../../models/equipmentsModel';
import { PagingResultsModel } from './../../models/pagingResultsModel';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { deepClone } from 'src/app/helpers/utils';
import { CampusModel } from '../../models/campusModel';
import { EquipmentPermissionsModel } from 'src/app/models/equipmentTypePermissionModel';


@Injectable()
export class EquipmentService {
  private readonly assetApiPath = `${environment.apiServer.webApiURL}/Asset`;

  constructor(private http: HttpClient) {
  }



  getMyAssignedEquipments(): Observable<AssignedEquipmentModel[]> {
    return this.http.get<AssignedEquipmentModel[]>(`${this.assetApiPath}/AssignedEquipments/`);
  }

  ///////////////////



  getAllCampuses(): Observable<CampusModel[]> {
    return this.http.get<CampusModel[]>(`${this.assetApiPath}/AllCampuses`);
  }

  loadEquipmentPermissionModalOptions(): Observable<any>{
    return this.http.get<any>(`${this.assetApiPath}/LoadEquipmentPermissionModalOptions`);
  }

  saveEquipmentPermissions(equipmentPermissions: EquipmentPermissionsModel): Observable<EquipmentPermissionsModel>{
    return this.http.post<any>(`${this.assetApiPath}/SaveEquipmentPermissions`, equipmentPermissions);
  }

  loadEquipmentPermissions(userId: number, roleId: number): Observable<any>{
    let route;
    if(userId != null){
      route = "User"
    }
    else{
      route = "Role"
    }
    return this.http.post<any>(`${this.assetApiPath}/LoadEquipmentPermissions${route}`, {userId: userId, roleId: roleId});
  }

  getSearchEquipments(filterSerial: string): Observable<PagingResultsModel<EquipmentModel>> {
    return this.http.post<PagingResultsModel<EquipmentModel>>(`${this.assetApiPath}/SearchEquipments`,
      { searchFilter: filterSerial });
  }

  createEquipment(equipment: EquipmentModel): Observable<EquipmentModel> {
    return this.http.post<EquipmentModel>(`${this.assetApiPath}/Equipment/`,
      equipment);
  }

  editEquipment(equipment: EquipmentModel): Observable<EquipmentModel> {
    return this.http.put<EquipmentModel>(`${this.assetApiPath}/Equipment/`,
      equipment);
  }

  deleteEquipment(equipment: EquipmentModel): Observable<any> {
    return this.http.delete<any>(`${this.assetApiPath}/Equipment/${equipment.id}`);
  }

  unarchiveEquipment(equipment: EquipmentModel): Observable<any> {
    return this.http.put<any>(`${this.assetApiPath}/UnarchiveEquipment/`, equipment);
  }


  getAllEquipments(filter: any)
    : Observable<PagingResultsModel<EquipmentWithAssignmentsModel>> {
    filter = deepClone(filter);
    if (!filter) {
      filter.filters = {};
    }

    
    return this.http.post<PagingResultsModel<EquipmentWithAssignmentsModel>>(`${this.assetApiPath}/AllEquipments`,
      filter
    );
  }

  getEquipmentTypes(){
    return this.http.get<EquipmentTypeModel[]>(`${this.assetApiPath}/GetEquipmentTypes`);
  }

  getAllEquipmentsExcel(filter: any)
    : Observable<PagingResultsModel<EquipmentWithAssignmentsModel>> {
    filter = deepClone(filter);
    if (!filter) {
      filter.filters = {};
    }
    return this.http.post<PagingResultsModel<EquipmentWithAssignmentsModel>>(`${this.assetApiPath}/AllExcelEquipments`,
      filter
    );
  }

  getAllClassCodes(): Observable<EquipmentClassCodeModel[] > {
    return this.http.get<EquipmentClassCodeModel[]>(`${this.assetApiPath}/AllClassCode`);
  }

  getAllClassifications(): Observable<EquipmentClassificationModel[]> {
    return this.http.get<EquipmentClassificationModel[]>(`${this.assetApiPath}/AllClassifications`);
  }

  assignEquipments(assignedEquipments: AssignedEquipmentModel[]): Observable<AssignedEquipmentModel[]> {
    return this.http.post<AssignedEquipmentModel[]>(`${this.assetApiPath}/AssignedEquipments`,
      assignedEquipments);
  }

  editAssignEquipments(assignedEquipments: AssignedEquipmentModel[]): Observable<AssignedEquipmentModel[]> {
    return this.http.post<AssignedEquipmentModel[]>(`${this.assetApiPath}/EditAssignedEquipments`,
      assignedEquipments);
  }

  returnEquipments(returnedEquipments: AssignedEquipmentModel[]): Observable<AssignedEquipmentModel[]> {
    return this.http.post<AssignedEquipmentModel[]>(`${this.assetApiPath}/AssignedEquipmentsReturned`,
      returnedEquipments);
  }
}
